<template>
  <div>
    <search-form
      :model="searchParams"
      :col="3"
      :items="items"
      :loading="loading"
      inline
      label-width="100px"
      @submit="handleSearch"
    ></search-form>

    <el-table v-loading="loading" :data="tableData" class="m-t-lg">
      <el-table-column label="歌曲ID" width="125" prop="trackId"></el-table-column>
      <el-table-column label="歌曲名" prop="trackName" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="专辑名" prop="albumName" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属艺人" width="200" v-slot="{ row }" show-overflow-tooltip>
        <singer-cell :singer-list="row.trackSingerList"></singer-cell>
      </el-table-column>
      <el-table-column label="歌曲状态" width="100" v-slot="{ row }">
        {{ statusMap[row.status] }}
      </el-table-column>
      <el-table-column label="ISRC" width="150" prop="isrc"></el-table-column>
      <el-table-column label="发行时间" width="170" prop="publicTime"></el-table-column>
      <el-table-column label="是否存在瑕疵" width="100" v-slot="{ row }">
        {{ switchMap[row.isDefect] }}
      </el-table-column>
      <el-table-column
        label="操作"
        width="140"
        fixed="right"
        align="center"
        v-slot="{ row }"
      >
        <el-button type="text" size="small" @click="handleToDetail(row)">查看歌曲详情</el-button>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.current"
      :page-sizes="[20, 50, 100, 1000, 2000]"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm'
import MultipleInput from '@/components/MultipleInput'
import SingerCell from '@/components/SingerCell'
import { paginationTableMixin } from '@/utils/mixins'
import { statusMap, switchMap } from '@/utils/constants'
import trackService from '@/api/track'
import { clearEmptyKey } from '@/utils/objUtil'

function defaultSearchParams() {
  return {
    trackIdList: [],
    trackName: '',
    albumName: '',
    singerName: '',
    status: undefined,
    publicTime: void (0),
    isDefect: undefined
  }
}

const searchConfigList = [
  {
    label: '歌曲ID',
    key: 'trackIdList',
    type: 'component',
    component: MultipleInput,
    componentProps: {
      placeholder: '多个歌曲ID请用英文逗号分隔',
      formatter: 'number',
      clearable: true
    }
  },
  {
    label: '歌曲名',
    key: 'trackName',
    type: 'text',
    componentProps: {
      placeholder: '请输入歌曲名',
      clearable: true
    }
  },
  {
    label: '专辑名',
    key: 'albumName',
    type: 'text',
    componentProps: {
      placeholder: '请输入专辑名',
      clearable: true
    }
  },
  {
    label: '所属艺人',
    key: 'singerName',
    type: 'text',
    componentProps: {
      placeholder: '请输入艺人名称',
      clearable: true
    }
  },
  {
    label: '歌曲状态',
    key: 'status',
    type: 'select',
    options: statusMap,
    componentProps: {
      placeholder: '请选择歌曲状态',
      clearable: true
    },
  },
  {
    label: '发行时间',
    key: 'publicTime',
    type: 'datetime',
    componentProps: {
      placeholder: '请选择发行时间',
      valueFormat: 'yyyy-MM-dd',
      clearable: true
    }
  },
  {
    label: '是否存在瑕疵',
    key: 'isDefect',
    type: 'select',
    options: switchMap,
    componentProps: {
      placeholder: '请选择是否存在瑕疵',
      clearable: true
    },
  }
]

export default {
  name: 'ContractRelateTrackList',
  components: {
    SearchForm,
    SingerCell
  },
  mixins: [paginationTableMixin],
  props: {
    contract: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      statusMap,
      switchMap,

      searchParams: defaultSearchParams(),
    }
  },
  computed: {
    items() {
      return searchConfigList
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    getParams() {
      const { searchParams } = this
      return clearEmptyKey(searchParams)
    },
    toFrontend(data) {
      return (data || []).map(item => {
        item.albumName = item.albumBase?.albumName ?? ''
        const cpList = item.trackCopyrightList.concat(item.trackMusicCopyrightList).concat(item.trackWordCopyrightList)
        item.isDefect = cpList.some(cp => !!cp.cpDefect) ? 1 : 0

        return item
      })
    },
    async fetchData() {
      this.loading = true
      const params = this.getParams()
      try {
        const { total, list } = await trackService.querySettlementData({
          ...params,
          contract: this.contract,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = total
        this.tableData = this.toFrontend(list)
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    },
    handleToDetail(row) {
      this.$router.push({ name: 'trackList', query: { tab: 'stored', contract: this.contract, trackIdList: [row.trackId] } })
    },
  }
}
</script>
